export const isPhoneNumber = {
  phoneNumber: (value: string): boolean => {
    return !value || /^(\+)?[0-9]{4,20}$/.test(value)
  },
}
